import { Box } from '@material-ui/core'
import { TasklistShareDropdown } from 'shared/components/Onboarding/Tasklist/TasklistShareDropdown'
import { useOnboardingChecklist } from 'shared/hooks/query/useOnboardingChecklist'
import { User } from 'shared/models/user'

import { OnboardingChecklistName } from '../../helpers/constants'
import { hasPermission, Permissions } from '../../Permissions'
import { UserOnboardingDeactivateCheckrCandidate } from './UserOnboardingDeactivateCheckrCandidate'
import { UserOnboardingManuallySyncHirerightPackages } from './UserOnboardingManuallySyncHirerightPackages'
import { UserOnboardingOrderDropdown } from './UserOnboardingOrderDropdown'
import { UserOnboardingSyncPackages } from './UserOnboardingSyncPackages'

interface UserOnboardingSidebarProps {
  user: User
  permissions: any
}

export function UserOnboardingSidebar({ user, permissions }: UserOnboardingSidebarProps) {
  const { checklist } = useOnboardingChecklist(user.id, {
    enabled: false,
  })
  const driverApplication = checklist.find((c) => c.name === OnboardingChecklistName.DRIVER_APPLICATION)
  const employmentHistory = checklist.find((c) => c.name === OnboardingChecklistName.EMPLOYMENT_HISTORY)
  const isCheckr =
    Boolean(user.permissions?.checkrPackage1Onboarding?.enabled) ||
    Boolean(user.permissions?.checkrPackage2Onboarding?.enabled)
  const canDeactivateCheckrCandidate =
    permissions && hasPermission(permissions, Permissions.DeactivateCheckrCandidate)

  return (
    <>
      {!user.driver.dateTermsAccepted && (
        <>
          <Box mt={2} />
          <TasklistShareDropdown user={user} />
        </>
      )}

      {employmentHistory && driverApplication && (
        <>
          <Box mt={2} />
          <UserOnboardingOrderDropdown
            user={user}
            employmentHistory={employmentHistory}
            driverApplication={driverApplication}
          />
        </>
      )}

      {!isCheckr && (
        <>
          <Box mt={2} />
          <UserOnboardingSyncPackages user={user} isCheckr={isCheckr} />
        </>
      )}

      {isCheckr && canDeactivateCheckrCandidate && (
        <>
          <Box mt={2} />
          <UserOnboardingDeactivateCheckrCandidate user={user} />
        </>
      )}

      {!isCheckr && canDeactivateCheckrCandidate && (
        <>
          <Box mt={2} />
          <UserOnboardingManuallySyncHirerightPackages user={user} />
        </>
      )}
    </>
  )
}
